import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';       // your login form component
import CategoryEditor from '../components/CategoryEditor'; // stub or your real one
import SlideEditor from '../components/SlideEditor';
import styled from 'styled-components';

const AdminContainer = styled.div`
  padding: 20px;
`;

const Section = styled.section`
  margin-top: 32px;
  padding: 16px;
  border: 1px solid #444;
  border-radius: 8px;
  background: #111;
`;

const SectionTitle = styled.h2`
  color: #e1d6c0;
  margin-bottom: 12px;
  font-size: 1.5rem;
`;

export default function AdminPage() {
  const [token, setToken] = useState(localStorage.getItem('jwt'));
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [pages, setPages] = useState([]);
  const bump = () => setRefreshFlag(f => !f);

  const reloadCats = () => {
    if (!token) return;
    setLoading(true);
    fetch('/api/admin/categories', {
      headers: { Authorization: 'Bearer ' + token }
    })
      .then(r => {
        if (!r.ok) throw new Error('Auth failed');
        return r.json();
      })
      .then(setCats)
      .catch(() => {
        localStorage.removeItem('jwt');
        setToken(null);
      })
      .finally(() => setLoading(false));
  };

  useEffect(reloadCats, [token, refreshFlag]);

  useEffect(() => {
    if (!token) return;
    fetch('/api/admin/pages', {
      headers: { Authorization: 'Bearer ' + token }
    })
      .then(r => r.json())
      .then(setPages);
  }, [token]);

  const reload = () => {
    fetch('/api/admin/pages', {
      headers: { Authorization: 'Bearer ' + token }
    })
      .then(r => r.json())
      .then(setPages);
  };

  // If not logged in, show the login form
  if (!token) {
    return <LoginForm onAuth={t => {
      localStorage.setItem('jwt', t);
      setToken(t);
    }} />;
  }

  // While we’re fetching after login…
  if (loading) {
    return <p style={{ padding: 20 }}>Loading…</p>;
  }

  return (
    <AdminContainer>
      <h1 style={{ color: '#e1d6c0' }}>Admin Menu Editor</h1>
      <button onClick={() => {
        localStorage.removeItem('jwt');
        setToken(null);
      }}>Log out</button>

      <Section>
        <SectionTitle>Manage Store Hours</SectionTitle>
      </Section>

      <Section>
        <SectionTitle>Manage Home Page Slides</SectionTitle>
        <SlideEditor token={token} onChange={bump} />
      </Section>

      <Section>
        <SectionTitle>Manage Categories</SectionTitle>
        {cats.map(cat => (
          <CategoryEditor
            key={cat.id}
            cat={cat}
            token={token}
            onChange={bump}
          />
        ))}
        {/* new category */}
        <CategoryEditor token={token} onChange={bump} />
      </Section>
    </AdminContainer>
  );
}